import React, { Component } from 'react';
import { ISubgridTableProps } from '../../types/propTypes';
import { ITableColumn } from '../../models/table';
import { ISubgridTableState } from '../../types/stateTypes';
import { Card, Accordion } from 'react-bootstrap';
import _ from 'lodash';
export class SubgridTable extends Component<ISubgridTableProps, ISubgridTableState> {
    constructor(props: ISubgridTableProps) {
        super(props);
        this.state = {
            data: props.data,
            columns: props.columns,
            sortOrder: props.sortOrder,
            sortColumn: props.sortColumn,
            rowsPerPage: props.rowsPerPage,
            currentPage: props.currentPage,
            childGridIndex: null,
        };
    }

    UNSAFE_componentWillReceiveProps(props: ISubgridTableProps) {
        this.setState({
            ...this.state,
            data: props.data,
            childGridIndex: props.childGridIndex,
            currentPage: props.currentPage,
            rowsPerPage: props.rowsPerPage,
            sortColumn: props.sortColumn,
            sortOrder: props.sortOrder,
        });
    }

    getClass = (header: ITableColumn): string => {
        let className = '';
        if (header.sortable) {
            className = 'sorting';
        }
        if (header.id === this.state.sortColumn) {
            className = `sorting_${this.state.sortOrder}`;
        }
        return header.className ? `${className} ${header.className}` : className;
    };
    getPageNo = (iCount: number, start: number, noOfPage: number, endPage: number): JSX.Element => {
        let pageNo = iCount;
        let pageNoDisplay = iCount.toString();
        if (iCount !== 1 && start === 1) {
            pageNo = 1;
            pageNoDisplay = '1...';
        }

        if (iCount !== 1 && start === 1) {
            pageNo = 1;
            pageNoDisplay = '1...';
        }

        if (iCount === endPage && iCount !== noOfPage) {
            pageNo = noOfPage;
            pageNoDisplay = `...${noOfPage}`;
        }

        return (
            <span
                className={this.props.currentPage === iCount ? 'pagination-span active' : 'pagination-span'}
                onClick={() => this.props.handlePageChange(pageNo, this.state.rowsPerPage)}
            >
                {pageNoDisplay}
            </span>
        );
    };
    renderPageList = (): Array<JSX.Element> => {
        const noOfPage = Math.ceil(this.props.totalCount / this.props.rowsPerPage);
        const pageList = [];
        let startPage = 1;
        if (this.props.currentPage - 2 >= 1) {
            startPage = this.props.currentPage - 2;
        }
        let endPage = noOfPage < startPage + 4 ? noOfPage : startPage + 4;
        if (startPage + 4 > noOfPage) {
            endPage = noOfPage;
        }
        if (this.props.currentPage === noOfPage) {
            startPage = this.props.currentPage - 4 >= 1 ? this.props.currentPage - 4 : 1;
        }
        if (this.props.currentPage > 1) {
            pageList.push(
                <li key="page-prev">
                    <span
                        className="pagination-span prevar"
                        onClick={() => this.props.handlePageChange(this.props.currentPage - 1, this.state.rowsPerPage)}
                    >
                        {this.props.t('table.pagination.prev')}
                    </span>
                </li>,
            );
        }
        for (let iCount = startPage, start = 1; iCount <= endPage; iCount++, start++) {
            pageList.push(<li key={iCount}>{this.getPageNo(iCount, start, noOfPage, endPage)}</li>);
        }
        if (this.props.currentPage < noOfPage) {
            pageList.push(
                <li key="page-next">
                    <span
                        className="pagination-span nxtar"
                        onClick={() => this.props.handlePageChange(this.props.currentPage + 1, this.state.rowsPerPage)}
                    >
                        {this.props.t('table.pagination.nrev')}
                    </span>
                </li>,
            );
        }
        return pageList;
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <Accordion>
                    <div className="table-responsive grid-table min-height" style={this.props.style}>
                        <table className="table table-border">
                            <thead>
                                <tr>
                                    <th></th>
                                    {this.props.columns.length > 0 &&
                                        this.props.columns.map((header: ITableColumn, index: number): JSX.Element => {
                                            if (!header.isVisible) return null;
                                            return (
                                                <th
                                                    className={this.getClass(header)}
                                                    {...header.props}
                                                    key={index}
                                                    style={header.style ? header.style : {}}
                                                    onClick={() => {
                                                        header.sortable && this.props.handleSorting(header.id);
                                                    }}
                                                >
                                                    {header.headerCell ? (
                                                        header.headerCell()
                                                    ) : (
                                                        <span>{header.label}</span>
                                                    )}
                                                </th>
                                            );
                                        })}
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.data &&
                                    this.props.data.length > 0 &&
                                    this.props.data.map((row: any, index: number) => {
                                        return (
                                            <>
                                                <tr key={index}>
                                                    <td key={index}>
                                                        <div
                                                            title={
                                                                this.props.childGridIndex === index
                                                                    ? t('chargeStation.button.collapse')
                                                                    : t('chargeStation.button.expand')
                                                            }
                                                            className={
                                                                this.props.childGridIndex === index
                                                                    ? 'accordion collapse-icon collapsed active'
                                                                    : 'accordion collapse-icon collapsed'
                                                            }
                                                            onClick={() => {
                                                                this.props.handleChildGrid(index, row);
                                                            }}
                                                        ></div>
                                                    </td>
                                                    {Object.entries(this.props.columns).map(
                                                        (col, cellIndex: number): JSX.Element => {
                                                            const column = this.props.columns[cellIndex];
                                                            if (!column.isVisible) return null;
                                                            const columnName = column.id;
                                                            const cellValue = _.get(row, columnName);
                                                            return (
                                                                <td
                                                                    key={cellIndex}
                                                                    className={column.className ? column.className : ''}
                                                                    style={column.style ? column.style : {}}
                                                                    {...column.props}
                                                                >
                                                                    {column.cell ? column.cell(row) : cellValue}
                                                                </td>
                                                            );
                                                        },
                                                    )}
                                                </tr>
                                                {this.props.childGridIndex === index && (
                                                    <tr className="collapse-block" style={{ backgroundColor: '#fff' }}>
                                                        <td colSpan={this.props.columns.length + 1}>
                                                            <div className="collapse show">
                                                                <Card.Body>
                                                                    <div className="nestedgridshadow">
                                                                        {this.props.renderChildComponent()}
                                                                    </div>
                                                                </Card.Body>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        );
                                    })}
                            </tbody>
                        </table>
                        {this.state.data && this.state.data.length <= 0 && (
                            <p className="text-center mt-2">{this.props.t('table.data.noData')}</p>
                        )}
                    </div>
                </Accordion>
                {this.props.data &&
                    this.props.data.length > 0 &&
                    (this.props.allowPageing === undefined || this.props.allowPageing === true) && (
                        <div className="container-fluid">
                            <div className="grid-bottom row">
                                <div className="col-lg">
                                    <div className="show-record">
                                        <span className="form-label">{this.props.t('table.pagination.showing')}</span>
                                        <select
                                            className="custom-select"
                                            value={this.props.rowsPerPage}
                                            onChange={(e) => this.props.handlePageChange(1, parseInt(e.target.value))}
                                        >
                                            <option value="10">10</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="paginetion">
                                        <ul className="clearfix">{this.renderPageList()}</ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
            </>
        );
    }
}

export default SubgridTable;
